import { render, staticRenderFns } from "./BrandsSlider.vue?vue&type=template&id=e9b8693a&scoped=true"
import script from "./BrandsSlider.vue?vue&type=script&lang=js"
export * from "./BrandsSlider.vue?vue&type=script&lang=js"
import style0 from "./BrandsSlider.vue?vue&type=style&index=0&id=e9b8693a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b8693a",
  null
  
)

export default component.exports